var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.deliveryNote
    ? _c("div", { staticClass: "main-content delivery-note-view-page" }, [
        _c("div", { staticClass: "page-header" }, [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(" " + _vm._s(_vm.deliveryNote.delivery_note_number)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-actions row" },
            [
              _vm.deliveryNote.status == "DRAFT" && _vm.userType == "anchor"
                ? _c(
                    "v-dropdown",
                    {
                      staticClass: "filter-container",
                      attrs: { "close-on-select": false, align: "left" },
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { slot: "activator", href: "#" },
                          slot: "activator",
                        },
                        [
                          _c(
                            "base-button",
                            { attrs: { color: "theme" } },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "ellipsis-h" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "delivery-note-sidebar" },
          [
            _vm.isSearching
              ? _c("base-loader")
              : _c(
                  "div",
                  { staticClass: "side-header" },
                  [
                    _c("base-input", {
                      attrs: {
                        placeholder: _vm.$t("general.search"),
                        "input-class": "delNote-search",
                        icon: "search",
                        type: "text",
                        "align-icon": "right",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onSearched()
                        },
                      },
                      model: {
                        value: _vm.searchData.searchText,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchData, "searchText", $$v)
                        },
                        expression: "searchData.searchText",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-group ml-3",
                        attrs: { role: "group", "aria-label": "First group" },
                      },
                      [
                        _c(
                          "v-dropdown",
                          {
                            staticClass: "filter-container",
                            attrs: { "close-on-select": false, align: "left" },
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: { slot: "activator", href: "#" },
                                slot: "activator",
                              },
                              [
                                _c(
                                  "base-button",
                                  {
                                    staticClass:
                                      "delNote-button delNote-filter-fields-btn",
                                    attrs: { color: "default", size: "medium" },
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "filter" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "filter-title" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("general.sort_by")) +
                                  "\n          "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "filter-items" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.searchData.orderByField,
                                    expression: "searchData.orderByField",
                                  },
                                ],
                                staticClass: "delNote-radio",
                                attrs: {
                                  id: "filter_delivery_note_date",
                                  type: "radio",
                                  name: "filter",
                                  value: "delivery_note_date",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.searchData.orderByField,
                                    "delivery_note_date"
                                  ),
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      return _vm.$set(
                                        _vm.searchData,
                                        "orderByField",
                                        "delivery_note_date"
                                      )
                                    },
                                    _vm.onSearched,
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "delNote-label",
                                  attrs: { for: "filter_delivery_note_date" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("deliveryNotes.delivery_note_date")
                                    )
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "filter-items" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.searchData.orderByField,
                                    expression: "searchData.orderByField",
                                  },
                                ],
                                staticClass: "delNote-radio",
                                attrs: {
                                  id: "filter_delivery_note_number",
                                  type: "radio",
                                  name: "filter",
                                  value: "delivery_note_number",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.searchData.orderByField,
                                    "delivery_note_number"
                                  ),
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      return _vm.$set(
                                        _vm.searchData,
                                        "orderByField",
                                        "delivery_note_number"
                                      )
                                    },
                                    _vm.onSearched,
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "delNote-label",
                                  attrs: { for: "filter_delivery_note_number" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "deliveryNotes.delivery_note_number"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "base-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip.top-center",
                                value: { content: _vm.getOrderName },
                                expression: "{ content: getOrderName }",
                                modifiers: { "top-center": true },
                              },
                            ],
                            staticClass:
                              "delNote-button delNote-filter-sorting-btn",
                            attrs: { color: "default", size: "medium" },
                            on: { click: _vm.sortData },
                          },
                          [
                            _vm.getOrderBy
                              ? _c("font-awesome-icon", {
                                  attrs: { icon: "sort-amount-up" },
                                })
                              : _c("font-awesome-icon", {
                                  attrs: { icon: "sort-amount-down" },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "side-content" },
              [
                _vm._l(_vm.deliveryNotes, function (deliveryNote, index) {
                  return _c(
                    "a",
                    {
                      key: index,
                      staticClass: "side-delivery-note",
                      attrs: { href: "#/" },
                      on: {
                        click: function ($event) {
                          return _vm.viewDeliveryNote(deliveryNote.id)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "left" }, [
                        deliveryNote.buyer_stakeholder
                          ? _c("div", { staticClass: "delNote-name" }, [
                              _c("p", [
                                deliveryNote.buyer_stakeholder.details
                                  .company &&
                                deliveryNote.buyer_stakeholder.details.company
                                  .name
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            deliveryNote.buyer_stakeholder
                                              .details.company.name
                                          ) +
                                          "\n              "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "delNote-number" }, [
                          _vm._v(_vm._s(deliveryNote.delivery_note_number)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right" }, [
                        _c("div", { staticClass: "delNote-date" }, [
                          _vm._v(
                            _vm._s(deliveryNote.formattedDeliveryNoteDate)
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                !_vm.deliveryNotes.length
                  ? _c("p", { staticClass: "no-result" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("deliveryNotes.no_matching_delivery_note")
                          ) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "delivery-note-view-page-container" }, [
          _c("iframe", {
            staticClass: "frame-style",
            attrs: { src: "" + _vm.shareableLink },
          }),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }